import { useEffect, useRef, useState } from "react";
import styles from 'css/components/clock.module.css'

type TimerProps = {
	/** Preferred prop: number of seconds to count down from */
	seconds?: number
	/** Control running state (default: true) */
	isRunning?: boolean
	/** Called once when the countdown reaches 0 */
	onComplete?: () => void
}

export const Timer = ({ seconds, isRunning =
     true, onComplete }: TimerProps) => {
	const startSeconds = (typeof seconds === 'number' ? seconds : 0)
	const [timeLeft, setTimeLeft] = useState<number>(startSeconds)

	// Reset when startSeconds changes
	useEffect(() => {
		setTimeLeft(startSeconds)
	}, [startSeconds])

	// Drive countdown while running
	useEffect(() => {
		if (!isRunning || startSeconds <= 0) return
		let remaining = startSeconds
		setTimeLeft(remaining)
		const id = setInterval(() => {
			remaining -= 1
			setTimeLeft(remaining)
			if (remaining <= 0) {
				clearInterval(id)
				try { onComplete?.() } catch {}
			}
		}, 1000)
		return () => clearInterval(id)
	}, [isRunning, startSeconds, onComplete])

	const minutes = Math.floor(timeLeft / 60)
	const secs = timeLeft % 60

	return (
		<div className={styles.clock}>
			{`${minutes}:${secs < 10 ? `0${secs}` : secs}`}
		</div>
	)
}

export const Stopwatch = () => {
    const [elapsedMs, setElapsedMs] = useState<number>(0)
    const startRef = useRef<number>(Date.now())

    useEffect(() => {
        const id = setInterval(() => {
            setElapsedMs(Date.now() - startRef.current)
        }, 1000)
        return () => clearInterval(id)
    }, [])

    const minutes = Math.floor(elapsedMs / 60000)
    const secs = Math.floor((elapsedMs / 1000) % 60)
    return (
        <div className={styles.clock}>
            {`${minutes}:${secs < 10 ? `0${secs}` : secs}`}
        </div>
    )
}